import React from 'react';
import { changedStyles } from '../WatchlistTableHelpers';
import { useSelector } from 'react-redux';

const AggregatedSentimentRenderer = ({ data, value }) => {
  const isColorEnable = useSelector(state => state.User.user?.enable_watchlist_color);
  const color = changedStyles[data.sentimentWord?.toLowerCase()]?.backgroundColor;

  return <span style={{ color: color && isColorEnable ? color : null }}>{value}</span>;
};

export default AggregatedSentimentRenderer;
